import { render, staticRenderFns } from "./DispenserView.vue?vue&type=template&id=bdd91db8"
import script from "./DispenserView.vue?vue&type=script&lang=js"
export * from "./DispenserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports